import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { EventCard, TeamEventCard } from '../../cards';
import { isAdultTeamTennisMatchById, isTeamMatchEvent } from '../../../utils/events';
import CreateEventButton from '../../Clubs/ClubProfile/CreateEventButton';

import eventStyles from './eventsDisplay.scss';
import styles from '../../../pages/ClubProfiles/club.scss';

class EventsCardList extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        const {
            events,
            listTypeName,
            clubName,
            clubId,
            auth,
            showAllLinkVisible,
            onShowAllClick,
            eventsTypeName,
            onCreateEventClick,
            isAdminOrOwner,
            isClubMember,
            limit,
            showAdminOptions,
            isCollege,
            onTeamMatchMenuSelected,
            isProfilePage,
        } = this.props;

        if (events && events.length > 0) {
            return (
                <div className={`${eventStyles.eventsDisplay}`}>
                    <div className="row">
                        {events.map((event, i) => {
                            if ((limit && i < 3) || this.state.seeAll || !limit) {
                                return (
                                    <div
                                        className="col-12"
                                        key={`${listTypeName}-event-${i}`}
                                    >
                                        {!isTeamMatchEvent(event.source) && !isAdultTeamTennisMatchById(event.eventTypeId) && (
                                            <EventCard
                                                event={event}
                                                clubName={clubName}
                                                clubId={clubId}
                                                auth={auth}
                                                force={{ hideOrganizer: true, cardView: true }}
                                                isClubMember={isClubMember}
                                                isProfilePage={isProfilePage}
                                            />
                                        )}
                                        {isTeamMatchEvent(event.source) && (
                                            <TeamEventCard
                                                event={event}
                                                clubName={clubName}
                                                clubId={clubId}
                                                auth={auth}
                                                showAdminOptions={showAdminOptions}
                                                isCollege={isCollege}
                                                onTeamMatchMenuSelected={onTeamMatchMenuSelected}
                                            />
                                        )}

                                        {isAdultTeamTennisMatchById(event.eventTypeId) && (
                                            <TeamEventCard
                                                event={event}
                                                clubName={clubName}
                                                clubId={clubId}
                                                auth={auth}
                                                showAdminOptions={showAdminOptions}
                                                onTeamMatchMenuSelected={onTeamMatchMenuSelected}
                                                isAdultTeamTennisClub={true}
                                            />
                                        )}
                                    </div>
                                );
                            }
                            return null;
                        })}
                    </div>
                    {((limit && events.length > 3) || showAllLinkVisible) && (
                        <div
                            className={`link clickable mt16 mb8`}
                            onClick={() => {
                                if (limit) {
                                    this.setState(prevState => ({
                                        seeAll: !prevState.seeAll,
                                    }));
                                } else {
                                    onShowAllClick(listTypeName);
                                }
                            }}
                        >
                            {limit && this.state.seeAll && (
                                <>See Less</>
                            )}
                            {limit && !this.state.seeAll && (
                                <>See All</>
                            )}
                            {!limit && (
                                <>See All {eventsTypeName}</>
                            )}
                        </div>
                    )}
                </div>
            );
        }

        if (isAdminOrOwner) {
            return (
                <div className={`${styles.placeHolderGrid}`}>
                    <div className={`${styles.overlay}`} />
                    <div className={`${styles.actionWrapper}`}>
                        <CreateEventButton onClick={onCreateEventClick} />
                    </div>
                </div>
            );
        }

        return (
            <div className="row mt64">
                <div className="col-12">
                    <p className="text-center">
                        No matches have been added yet <br />
                        Check back for team matches
                    </p>
                </div>
            </div>
        );
    }
}

EventsCardList.propTypes = {
   isProfilePage: PropTypes.bool,
};
EventsCardList.defaultProps = {
    isProfilePage: false,
};
export default EventsCardList;
